export default __webpack_public_path__ + "static/media/contact.a84ba200.png";